<template>
  <div>
    <van-popup
      v-model="isShowLottery"
      round
      position="bottom"
      closeable
      class="van-popup-wrapper"
      @click-overlay="closePop"
      @click-close-icon="closePop"
    >
      <div class='preview'
           :style="setData.skin_style == '1' ? {background: setData.skin_color} : {backgroundImage: `url(${setData.custom_bg_img})`}">
        <div class='lottery-img-show'
             :style="{background: setData.is_open_lottery_img=='1' ? `url(${setData.lottery_img}) no-repeat scroll top center/100%`:''}">
          <h3>{{setData.title}}</h3>
          <p v-if="setData.is_open_lottery_intro=='1'">{{setData.lottery_intro}}</p>
          <div class='lottery-wrapper'>
            <ul class='right-nav'>
              <li @click="openPopup('isShowRewardList','我的奖品')">
                我的奖品
              </li>
              <li @click="openPopup('isShowRule','活动规则')">
                活动规则
              </li>
            </ul>
            <div class='lottery-content'
                 :style="{backgroundImage: `url(${setData.dial_img})`}"
                 ref="plate"
            >
              <img :key="item.prizeId"
                   v-for="item in prizenList"
                   :value="item.prizeId"
                   :src="item.prizenImgUrl"/>
            </div>
            <img :src="setData.pointer_img" alt="" class="pointer" @click="compare(null,'first')"/>
          </div>
          <p class='btn' @click="compare(null,'first')">{{setData.button_text}}</p>
          <p v-if="setData.is_open_goal_list=='1'"
             class="goal_list" >
            <span @click="openPopup('isShowGoalList','中奖名单')">中奖名单</span>
          </p>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="isShowDerivative"
      round
      position="bottom"
      closeable
      class="derivative-popup-wrapper"
    >
      <div class="title-box">
        {{derivative.title}}
      </div>
      <div class="content">
        <div class="reward-list comment-list" v-if="isShowRewardList">
          <ul v-if="rewardList.length">
            <li v-for="(item,index) in rewardList"
                :key="index">
              <span>{{item.prize_name}}</span>
              <span>{{item.created_at}}</span>
            </li>
          </ul>
          <div class="null-list" v-else>
            <img src="../assets/null-reward-list.png" alt="">
            <p>暂无数据~</p>
          </div>
        </div>
        <div class="goal-list  comment-list" ref="goalList"
             v-if="isShowGoalList">
          <ul v-if="goalList.length">
            <li v-for="(item,index) in goalList"
                :key="index">
                     <span>
                       {{item.nickname}}
                       <br/>
                        {{item.tel}}
                     </span>
              <span>
                       {{item.prize_name}}
                       <br/>
                       {{item.created_at}}
                     </span>
            </li>
          </ul>
          <div class="load-end"
               v-if="listLoad && goalList.length && noMore">
            <span>暂无更多内容</span>
          </div>
          <more-loading v-show="moreLoading"></more-loading>
          <page-loading v-if="!listLoad"></page-loading>
          <div class="null-list" v-if="listLoad &&!goalList.length">
            <img src="../assets/null-gold-list.png" alt="">
            <p>暂无中奖数据~</p>
          </div>
        </div>
        <div class="rule" v-if="isShowRule" v-html="setData.rule">
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="isShowLotteryReward"
      round
      closeable
      class="lottery-reward-popup"
      close-icon="close"
      close-icon-position="bottom-left"
      @close="closePop"
    >
      <div :class="['content',rewardObj.is_goal=='1'?'reward':'unReward']">
        <div class="reward-box">
          <img :src="rewardObj.prize_img" alt="">
        </div>
        <p>{{rewardObj.is_goal =='1'?'中奖信息将以短信形式通知您，请如实填写收货信息，如有疑问可咨询：400-0057-511':'如有疑问可咨询：400-0057-511'}}</p>
      </div>
    </van-popup>
    <!--阿里验证 -->
    <div class="ali-submit"
         id="submit"></div>
  </div>
</template>
<script>
import XHR, { lotteryApi } from '../api'
import MoreLoading from '../plugins/loading/moreLoading'
import PageLoading from '../plugins/loading/pageLoading'
import Md5 from 'js-md5'

export default {
  name: 'Lottery',
  props: {
    setData: {
      type: Object,
      default: () => {
      }
    },
    uid: {
      type: String,
      default: '0'
    }
  },
  components: {
    MoreLoading,
    PageLoading
  },
  data: () => ({
    isShowLottery: true,
    isShowDerivative: false,
    prizenList: [],
    isShowRewardList: false,
    isShowRule: false,
    isShowGoalList: false,
    isShowLotteryReward: false,
    derivative: {
      title: ''
    },
    rewardList: [],
    goalList: [],
    rewardObj: {
      is_goal: '1',
      prize_img: ''
    },
    isLock: false, // 抽奖加锁,
    page: 1,
    // 是否显示无数据
    noMore: false,
    // 加载数据开关
    loadFlag: false,
    // 加载动画
    listLoad: false,
    // 加载更多开关
    moreLoading: false,
    netWork: false
  }),
  filters: {},
  created () {
    this.getPrizeList()
  },
  mounted () {
    const obj = { id: '#submit', width: 340, height: 50 }
    window.aliInit('', this.compare, obj)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollMore)
    /* eslint-disable */
    var js = /js$/i.test('https://g.alicdn.com/sd/nvc/1.1.112/guide.js');
    var es = document.getElementsByTagName(js ? 'script' : 'link');
    window.NVC_Opt = null
    if (getNC) {
      getNC = null
    }
    for (var i = 0; i < es.length; i++) {
      if (es[i][js ? 'src' : 'href'].indexOf('https://g.alicdn.com/sd/nvc/1.1.112/guide.js') != -1) {
        es[i].parentNode.removeChild(es[i])
        return
      }
    }
    /* eslint-enable */
  },
  methods: {
    closePop () {
      this.$emit('close')
    },
    getPrizeList () {
      const params = {
        aid: this.setData.activity_id
      }
      XHR.getPrizeList(params).then(res => {
        const { data, status } = res.data
        if (!status) {
          this.prizenList = data
        }
      })
    },
    openPopup (type, title) {
      this.isShowDerivative = true
      this.isShowGoalList = false
      this.isShowRule = false
      this.isShowRewardList = false
      this[type] = true
      this.derivative.title = title
      if (type === 'isShowRewardList') {
        this.getMyPrizeList()
      } else if (type === 'isShowGoalList') {
        this.$nextTick(() => {
          this.$refs.goalList.addEventListener('scroll', this.scrollMore, false)
        })
        this.page = 1
        this.goalList = []
        this.getGoalList()
      }
    },
    compare (token, type = '') {
      // 去抽奖逻辑
      if (!this.uid || this.uid === '0') {
        this.$emit('login')
        return false
      } else {
        const params = {
          id: this.setData.rid,
          uid: this.uid
        }
        if (type != null && type === 'first') {
          if (this.isLock) {
            return
          }
          this.isLock = true
          params.nvcVal = window.getNVCVal()
          const param = this.encryptionJson(params)
          const md5 = Md5(params.timestamp + 'uateP9a4jm7okKCw')
          window.yourRegisterRequest(lotteryApi,
            param, this.handleData, md5)
        } else {
          params.nvcVal = token
          this.aliReset()
          XHR.toLottery(params).then(res => {
            this.aliReset()
            this.handleData(res.data)
          }).catch(() => {
            this.isLock = false
            this.aliReset()
            this.showErrorInfo('网络原因，稍后重试')
          })
        }
      }
    },
    // 数据处理逻辑
    handleData (res) {
      const { msg, status, data } = res
      if (status === 0) {
        this.rewardObj = data
        this.luckyDraw(data.prize_id)
      } else if (status === '400') {
        this.isLock = false
      } else {
        this.isLock = false
        this.showErrorInfo(msg)
      }
    },
    luckyDraw (id = '0') {
      let index = null
      for (var i = 0; i < this.prizenList.length; i++) {
        if (id === this.prizenList[i].prizeId) {
          index = i
          break
        }
      }
      // this.turntableReward = this.rewardList[index]
      if (this.$refs && this.$refs.plate) {
        this.$refs.plate.style.transform = `rotate(${3600 + (index * -45)}deg)`
        this.$refs.plate.style.transition = 'transform 5s ease-in-out'
        const drawTimer = setTimeout(() => {
          // 转盘恢复初始状态
          const rotate = (index * -45)
          this.$refs.plate.style.transition = 'none'
          this.$refs.plate.style.transform = `rotate(${rotate}deg)`
          drawTimer && clearTimeout(drawTimer)
          this.isShowLottery = false
          this.isLock = false
          this.isShowLotteryReward = true
        }, 5400)
      }
    },
    // 获取我的奖品列表
    getMyPrizeList () {
      if (!this.uid || this.uid === '0') {
        this.$emit('login')
        return false
      } else {
        const params = {
          id: this.setData.rid,
          uid: this.uid
        }
        XHR.getMyGoal(params).then(res => {
          const { msg, status, data } = res.data
          if (!status) {
            this.rewardList = data
          } else {
            this.showErrorInfo(msg)
          }
        })
      }
    },
    // 获取直播间奖品列表
    getGoalList () {
      const params = {
        id: this.setData.rid,
        page: this.page,
        size: 20
      }
      XHR.getGoalList(params).then(res => {
        const { status, data } = res.data
        if (!status && data.list.length) {
          this.goalList = [...this.goalList, ...data.list]
          this.loadFlag = false
        } else {
          this.loadFlag = true
          this.noMore = true
          // this.showErrorInfo(msg)
        }
        this.moreLoading = false
        this.listLoad = true
      }).catch(() => {
        this.showErrorInfo('网络错误，请稍后重试')
        // if (this.page === 1) {
        //   this.showErrorInfo('网络错误，请稍后重试')
        // } else {
        //   this.netWork = true
        //   this.loadFlag = false
        //   this.notNetDo()
        // }
      })
    },
    // 滚动加载更多
    scrollMore (e) {
      // if (this.noMore) return
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      var scrollHeight = document.documentElement.scrollheight || document.body.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight - 100 && !this.loadFlag) {
        this.moreLoading = true
        this.loadFlag = true
        if (this.netWork === false) {
          this.page++
        } else {
          this.netWork = false
        }
        this.getGoalList()
      }
    },
    aliReset () {
      if (window.nvcReset) {
        window.nvcReset()
      }
      // 重置样式
      const ncDiv = document.querySelector('#submit')
      if (ncDiv) {
        ncDiv.innerHTML = ''
      }
    }
  }
}
</script>
<style scoped lang="less">
  .ali-submit {
    position: fixed;
    width: 350px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 4001;
  }
  .van-popup-wrapper {
    /*position:relative;*/
    .preview {
      position: relative;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      background-size: 100% 100%; .right-nav {
        position: absolute;
        right: -11px;
        top: -13px;
        z-index: 3;
        li {
          position: relative;
          width: 69px;
          height: 26px;
          padding-right: 2px;
          box-sizing: border-box;
          margin-bottom: 8px;
          border-radius: 17px 0px 0px 17px;
          background: rgba(0, 0, 0, 0.4);
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 26px;
          text-align: right;

          &:before {
            position: absolute;
            top: 6px;
            left: 6px;
            width: 12px;
            height: 12px;
            content: '';
          }

          &:nth-of-type(1):before {
            background: url('../assets/reward_icon.png');
            background-size: 100% 100%;
          }

          &:nth-of-type(2):before {
            background: url('../assets/rule_icon.png');
            background-size: 100% 100%;

          }
        }
      }

      .lottery-img-show {
        padding: 15px 12px;
        /*border-top-left-radius: 20px;*/
        /*border-top-right-radius: 20px;*/
        background-size: 100%;
      }

      h3 {
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 25px;
        text-align: center;
      }

      p {
        margin-top: 19px;
        font-size: 15px;
        line-height: 21px;
        color: #FFFFFF;
      }

      .lottery-wrapper {
        position: relative;
        width: 351px;
        height: 300px;
        margin-top: 22px;
        padding: 0 28px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 11px 11px 0 0;
        transform: translate3d(0,0,0);
        .pointer {
          position: absolute;
          top: 90px;
          left: 50%;
          transform: translateX(-50%);
          width: 90px;
          height: 114px;
          z-index: 10;
        }
        .lottery-content {
          position: relative;
          width: 300px;
          height: 300px;
          margin-left: auto;
          margin-right: auto;
          background-size: 100% 100%;
          img {
            position: absolute;
            width: 84px;
            height: 63px;
            &:nth-of-type(1) {
              top: 34px;
              left: 50%;
              transform: translateX(-50%) rotate(0deg);
            }
            &:nth-of-type(2) {
              top: 58px;
              left: 57%;
              transform: rotate(45deg);
            }

            &:nth-of-type(3) {
              top: 120px;
              left: 66%;
              transform: rotate(90deg);
            }

            &:nth-of-type(4) {
              top: 180px;
              left: 56%;
              transform: rotate(135deg);
            }

            &:nth-of-type(5) {
              bottom: 34px;
              left: 50%;
              transform: translateX(-50%) rotate(180deg);
            }

            &:nth-of-type(6) {
              top: 180px;
              left: 16%;
              transform: rotate(225deg);
            }

            &:nth-of-type(7) {
              top: 120px;
              left: 7%;
              transform: rotate(270deg);
            }

            &:nth-of-type(8) {
              top:58px;
              left:16%;
              transform: rotate(315deg);
            }
          }
        }
      }

      .btn {
        width: 299px;
        height: 40px;
        margin-left: auto;
        margin-right: auto;
        background: #FFD12E;
        border-radius: 24px;
        line-height: 40px;
        font-size: 18px;
        color: #A51606;
        text-align: center;
        /*font-weight: bold;*/
      }

      .goal_list {
        /*display: inline-block;*/
        text-align: center;
        /*width: 48px;*/
        height: 17px;
        margin: 6px auto 0;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 17px;
        span{
          cursor: pointer;
          display: inline-block;
          border-bottom: 1px solid rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  .derivative-popup-wrapper {
    padding: 45px 12px 2px;
    box-sizing: border-box;
    background: #E53A3D;
    /deep/ .van-icon-cross:before {
      color: rgba(255, 255, 255, 0.7)
    }

    .title-box {
      position: absolute;
      top: -14px;
      left: 50%;
      transform: translateX(-50%);
      width: 375px;
      height: 90px;
      padding-top: 29px;
      box-sizing: border-box;
      background: url('../assets/title-box.png') no-repeat;
      background-size: 100% 100%;
      /*z-index:3002;*/
      font-size: 20px;
      font-weight: bold;
      color: #FDF9D7;
      text-align: center;
      /*line-height: 40px;*/
    }

    .content {
      /*height:300px;*/
      background: #fff;
      padding: 34px 15px 0;
      border-radius: 11px 11px 0px 0px;

      .null-list {
        padding-bottom: 97px;

        img {
          display: block;
          width: 140px;
          height: 110px;
          margin: 63px auto 2px;
        }

        p {
          font-size: 20px;
          color: rgba(23, 24, 26, 0.4);
          line-height: 28px;
          text-align: center;
        }
      }

      .comment-list {
        height: 440px;
        overflow-y: scroll;
        padding-bottom: 15px;
        box-sizing: border-box;
        ul li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 22px;
          font-size: 15px;
          color: #03102A;
          opacity: 0.8;
          line-height: 25px;
        }
      }

      .reward-list {
        padding-left: 13px;
        padding-right: 13px;

        ul li {
          span {
            &:nth-of-type(1) {
              width: 133px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .goal-list {
        li {
          padding: 7px 5px;
          line-height: 22px;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &:nth-of-type(1) {
              width: 92px;
            }

            &:nth-of-type(2) {
              width: 144px;
            }
          }
          &:nth-of-type(2n) {
            background: #FFF3EB;
            opacity: 0.98;
          }
        }
      }

      .rule {
        height: 440px;
        overflow-y: scroll;
        padding-bottom: 33px;
        box-sizing: border-box;
        font-size: 15px;
        color: rgba(23, 24, 26, 0.8);
        line-height: 22px;
      }
    }
  }

  .lottery-reward-popup {
    &.van-popup {
      background-color: transparent;
    }

    /deep/ .van-popup__close-icon {
      position: static;
      margin: 24px auto 0;
      display: block;
      font-size: 32px;
      text-align: center;
    }

    .content {
      width: 336px;
      height: 371px;
      p {
        width: 253px;
        margin: 0 auto;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
        line-height: 18px;
      }

      img {
        display: block;
        width: 172px;
        height: 130px;
        /*margin:0 auto;*/
      }

      .reward-box {
        display: flex;
        padding-top: 154px;
        height: 132px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /*padding-top:150px;*/
        /*background:#333;*/
      }
    }

    .reward {
      background: url("../assets/reward.png") no-repeat center center/ 100%;
      p {
        margin-top: 16px;
      }
    }
    .unReward {
      background: transparent url("../assets/unreward.png") no-repeat center center/ 100%;

      p {
        margin-top: 22px;
      }
    }
  }

  .load-end {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 40px 0;
    box-sizing: border-box;
    font-size: 12px;
    color: rgba(3, 16, 42, 0.4);
    line-height: 17px;

    span {
      margin: 0 10px;
    }
  }
</style>
